import type { AppApi } from '@wix/wix-data-client-common'

export interface PageLinkGenerationPayload {
  collectionId: string
  fields: string[]
}

export const onPageLinkGeneration = async (
  appApi: AppApi,
  { collectionId, fields }: PageLinkGenerationPayload,
): Promise<void> => {
  await appApi.refreshRoutersAndEmitPageLinkGenerationEvent({
    collectionId,
    pageLinkKeys: fields,
  })
}
